const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);
    const variantParam = urlParams.get('variant');
    const variants = document.querySelectorAll('.variant-selector-parent .variant-selected')
    console.log(variants)
    variants.forEach( variant => {
      const variantID = variant.id;
      if(variantID === variantParam){
        variant.classList.add('selected-box');
      } else {
        const options = document.querySelectorAll('#Option1 > option')
        options.forEach(option => {
            console.log(option)
            if(option.getAttribute('selected') == 'selected' && option.getAttribute('data-value-handle') == variant.getAttribute('data-value-handle')){
                variant.classList.add('selected-box')
            }
        })
      }
    });
  